export default __webpack_public_path__ + "static/media/bg-categories-bottom.1573c6dd.svg";